var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("FIELD.INACTIVE.TITLE")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("table", { staticClass: "create_table noLine" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBSIDIARY")))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.searchDeptNm))]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.USER.NAME")))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.searchLoginName))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY")))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { attrs: { colspan: "3", "data-input-type": "select" } },
                    [
                      _c("fieldset", { staticClass: "ui_fieldset set_2" }, [
                        _c("label", { staticClass: "select-wrap" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inquiry1Code,
                                  expression: "inquiry1Code"
                                }
                              ],
                              staticClass: "slt_white w100p",
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.inquiry1Code = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.inquiryList(2)
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("FIELD.FAST.DURATION.ALL"))
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.inquiry1CodeList, function(item) {
                                return _c(
                                  "option",
                                  {
                                    key: _vm.pageName + item.CD,
                                    domProps: { value: item.CD }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                    " +
                                        _vm._s(item.CD_NAME) +
                                        "\n                                                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "select-wrap" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inquiry2Code,
                                  expression: "inquiry2Code"
                                }
                              ],
                              staticClass: "slt_white w100p",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.inquiry2Code = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("FIELD.FAST.DURATION.ALL"))
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.inquiry2CodeList, function(item) {
                                return _c(
                                  "option",
                                  {
                                    key: _vm.pageName + item.CD,
                                    domProps: { value: item.CD }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                    " +
                                        _vm._s(item.CD_NAME) +
                                        "\n                                                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { attrs: { colspan: "3", "data-input-type": "select" } },
                    [
                      _c("fieldset", { staticClass: "ui_fieldset set_3" }, [
                        _c("label", { staticClass: "select-wrap" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.category1Code,
                                  expression: "category1Code"
                                }
                              ],
                              staticClass: "slt_white w100p",
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.category1Code = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.categoryList(2)
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("FIELD.FAST.DURATION.ALL"))
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.category1CodeList, function(item) {
                                return _c(
                                  "option",
                                  {
                                    key: _vm.pageName + item.code,
                                    domProps: { value: item.code }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                    " +
                                        _vm._s(item.codeName) +
                                        "\n                                                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "select-wrap" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.category2Code,
                                  expression: "category2Code"
                                }
                              ],
                              staticClass: "slt_white w100p",
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.category2Code = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.categoryList(3)
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("FIELD.FAST.DURATION.ALL"))
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.category2CodeList, function(item) {
                                return _c(
                                  "option",
                                  {
                                    key: _vm.pageName + item.code,
                                    domProps: { value: item.code }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                    " +
                                        _vm._s(item.codeName) +
                                        "\n                                                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "select-wrap" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.category3Code,
                                  expression: "category3Code"
                                }
                              ],
                              staticClass: "slt_white w100p",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.category3Code = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("FIELD.FAST.DURATION.ALL"))
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.category3CodeList, function(item) {
                                return _c(
                                  "option",
                                  {
                                    key: _vm.pageName + item.code,
                                    domProps: { value: item.code }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                    " +
                                        _vm._s(item.codeName) +
                                        "\n                                                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid_wrap mt-20" },
              [
                _c("div", { staticClass: "grid_total" }, [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.$t("TITLE.TOTAL.COUNT")) +
                      " "
                  ),
                  _c("em", [_vm._v(_vm._s(_vm.gridData.length))])
                ]),
                _vm._v(" "),
                _c("toast-grid", {
                  key: _vm.gridKey,
                  ref: _vm.gridId,
                  attrs: {
                    gridId: _vm.gridId,
                    columns: _vm.columns,
                    data: _vm.gridData,
                    isTotalCount: false,
                    options: _vm.options,
                    pageOptions: _vm.pageOptions
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "17%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "17%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15fd58d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15fd58d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/qnaManager/popup/inactiveAnswererPop.vue
// module id = 4AwI
// module chunks = 0